<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->

<ng-template #tableHead>
  <div class="flex items-center justify-end gap-3 w-full">
    <div class="flex items-center gap-2">
      <span class="text-sm font-medium text-slate-600">Sort by:</span>
      <nz-select
        style="width: 220px"
        [(ngModel)]="sortKey"
        (ngModelChange)="applyFilters()"
        nzPlaceHolder="Sort By"
      >
        <nz-option
          *ngFor="let option of sortOptions"
          [nzLabel]="option.label"
          [nzValue]="option.value"
        ></nz-option>
      </nz-select>
    </div>

    <nz-switch
      [(ngModel)]="showTesting"
      (ngModelChange)="testFilterFn()"
      nzCheckedChildren="Hide Test Users"
      nzUnCheckedChildren="Show Test Users"
    >
    </nz-switch>

    <button
      class="btn-color"
      nz-button
      nzSize="small"
      nzType="primary"
      (click)="clearFilter()"
    >
      Clear Filter
    </button>
  </div>
</ng-template>

<div class="p-6 space-y-4">
  <div>
    <h1 class="text-2xl font-bold text-slate-900">View Lyfis Scores</h1>
    <p class="text-sm text-slate-500">
      Users with persisted LYFIS score history
    </p>
  </div>

  <nz-table
    #basicTable
    [nzData]="rows"
    [nzLoading]="loading"
    [nzFrontPagination]="false"
    [nzTotal]="total"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzTitle]="tableHead"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>Snapshots</th>
        <th>Latest GHS</th>

        <th>
          Latest GHS Band
          <nz-filter-trigger
            [nzActive]="selectedBands.length > 0"
            [nzDropdownMenu]="ghsBandMenu"
          >
            <span nz-icon nzTheme="outline" nzType="filter"></span>
          </nz-filter-trigger>
        </th>

        <th>Latest Snapshot</th>

        <th>
          Partner ID

          <nz-filter-trigger
            [nzActive]="selectedPartnerIds.length > 0"
            [nzDropdownMenu]="partnerIdMenu"
          >
            <span nz-icon nzTheme="outline" nzType="filter"></span>
          </nz-filter-trigger>

          <nz-filter-trigger
            [nzActive]="!!partnerSearch"
            [nzDropdownMenu]="partnerIdSearchMenu"
          >
            <span nz-icon nzTheme="outline" nzType="search"></span>
          </nz-filter-trigger>
        </th>

        <th>Latest Trigger</th>
        <th>Action</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of basicTable.data">
        <td>{{ row.lyfisSnapshotCount }}</td>
        <td>{{ row.latestGhs }}</td>
        <td>{{ row.latestGhsBand || "—" }}</td>

        <td>
          {{
            row.latestSnapshotCreatedAt
              ? (row.latestSnapshotCreatedAt | date: "medium")
              : "—"
          }}
        </td>

        <td>{{ row.partnerId || "—" }}</td>
        <td>{{ row.latestTrigger || "—" }}</td>

        <td>
          <button nz-button nzType="link" (click)="openUser(row)">Open</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<!-- Partner Filter -->
<nz-dropdown-menu #partnerIdMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">Partner ID</span>
    <nz-divider></nz-divider>

    <nz-checkbox-wrapper (nzOnChange)="partnerIdFilterChangeFn($event)">
      <div *ngFor="let topic of partnerIdCheckBoxOptions">
        <label nz-checkbox [nzValue]="topic.value" [ngModel]="topic.checked">
          {{ topic.label }}
        </label>
      </div>
    </nz-checkbox-wrapper>

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="partnerIdFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="clearFilter()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- GHS Band Filter -->
<nz-dropdown-menu #ghsBandMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">GHS Band</span>
    <nz-divider></nz-divider>

    <nz-checkbox-wrapper (nzOnChange)="ghsBandFilterChangeFn($event)">
      <div *ngFor="let topic of ghsBandCheckBoxOptions">
        <label nz-checkbox [nzValue]="topic.value" [ngModel]="topic.checked">
          {{ topic.label }}
        </label>
      </div>
    </nz-checkbox-wrapper>

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="ghsBandFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="clearFilter()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Partner Search -->
<nz-dropdown-menu #partnerIdSearchMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">Partner ID</span>
    <nz-divider></nz-divider>

    <input
      nz-input
      placeholder="Search partnerId"
      [(ngModel)]="partnerSearch"
      (keyup.enter)="partnerIdFilterFn()"
    />

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="partnerIdFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="partnerSearch = ''; partnerIdFilterFn()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>
